import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { useT } from '../services/i18n';

const G = () => (
  <svg viewBox="0 0 48 48" width="22" height="22" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"/><path fill="#FBBC05" d="M10.5 28.7c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7l-7.9-6.1C.9 16.6 0 20.2 0 24s.9 7.4 2.6 10.8l7.9-6.1z"/><path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.5-5.8c-2.1 1.4-4.8 2.3-8.1 2.3-6.3 0-11.6-4.1-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/></svg>
);

const Stars = ({ value }) => (
  <span className="inline-flex items-center gap-0.5">{[1, 2, 3, 4, 5].map(i => <Star key={i} size={12} className={i <= Math.round(value || 0) ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'} />)}</span>
);

/** Home: Google Business Profile rating + latest Google reviews (fed by google_business.py cache). */
const GoogleBusinessBlock = ({ data }) => {
  const { t } = useT();
  if (!data || data.rating == null) return null;
  return (
    <aside className="w-full lg:w-[320px] shrink-0 bg-white border border-gray-200 rounded-xl p-4 flex flex-col gap-3" data-testid="google-business-block">
      <div className="flex items-center gap-3">
        <G />
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">{t('home.google.title')}</p>
          <p className="text-sm font-bold text-gray-900 inline-flex items-center gap-2" data-testid="google-business-rating"><span className="text-xl">{Number(data.rating).toFixed(1)}</span><Stars value={data.rating} /><span className="font-normal text-gray-500">({t('home.google.count', { n: data.count || 0, count: data.count || 0 })})</span></p>
        </div>
      </div>
      <ul className="space-y-2 flex-1">
        {(data.reviews || []).slice(0, 3).map((r, i) => (
          <li key={i} className="text-xs text-gray-700 border-t border-gray-100 pt-2" data-testid={`google-review-${i}`}>
            <div className="flex items-center gap-2">
              {r.photo ? <img src={r.photo} alt="" className="w-6 h-6 rounded-full" referrerPolicy="no-referrer" /> : <span className="w-6 h-6 rounded-full bg-[#4285F4] text-white text-[10px] flex items-center justify-center font-bold">{(r.author || 'G').charAt(0)}</span>}
              <span className="font-medium text-gray-900 truncate">{r.author}</span>
              <Stars value={r.rating} />
              <span className="text-gray-400 ml-auto whitespace-nowrap">{r.relative_time}</span>
            </div>
            {r.text && <p className="mt-1 line-clamp-2">« {r.text} »</p>}
          </li>
        ))}
      </ul>
      {data.url && <a href={data.url} target="_blank" rel="noopener noreferrer" className="text-xs font-medium text-[#1a73e8] hover:underline inline-flex items-center gap-1" data-testid="google-business-link">{t('home.google.link')} <ExternalLink size={11} /></a>}
    </aside>
  );
};

export default GoogleBusinessBlock;
